import React from 'react';
import ExpandableContainer from '../ExpandableContainer';
import * as Row from '../../../layout/Row';

export default class SummaryUnitTypeSection extends React.Component {
    render() {
        return (
            <ExpandableContainer label={__('Unit type')} initialOpen={true}>
                <Row.Container className="spaced-items-group-xs" hasOuterGutter={false}>
                    <div className="spaced-item column-4 column-xs-12">{this.renderGeneralInformation()}</div>

                    <div
                        className="spaced-item column-4 column-xs-12">{!this.props.model.unitType.isCustomLogic.value && this.renderDifferentialPressure()}</div>
                    <div
                        className="spaced-item column-4 column-xs-12">{!this.props.model.unitType.isCustomLogic.value && this.renderDesignData()}</div>

                </Row.Container>
            </ExpandableContainer>
        )
    }

    renderGeneralInformation() {
        const unitTypeModel = this.props.model.unitType
        const selectedModel = unitTypeModel.productType.items.find(x => x.value === unitTypeModel.productType.value)
        const selectedSetup = unitTypeModel.systemSetup.items.find(x => x.value === unitTypeModel.systemSetup.value)

        return (
            <div className="configuration-editor-summary-ut-section">
                <div>{__('General information')}</div>
                <div>
                    <table className="configuration-editor-summary-table">
                        <tbody>
                        <tr>
                            <td>{__('Model')}</td>
                            <td>{selectedModel.text}</td>
                        </tr>
                        {false &&

                            <tr>
                                <td>{__('Setup')}</td>
                                <td>{selectedSetup.text}</td>
                            </tr>
                        }

                        {false && <tr>
                            <td>{__('Options')}</td>
                            <td>{unitTypeModel.energyMeter.value && 'Energy meter'}</td>
                        </tr>}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    renderDesignData() {
        const model = this.props.model

        const hasHeating1DesignData = typeof model.heating1 !== 'undefined'
        const hasHeating2DesignData = typeof model.heating2 !== 'undefined'
        const hasHeating3DesignData = typeof model.heating3 !== 'undefined'
        const hasDHWDesignData = typeof model.dhw !== 'undefined'
        const hasDesignData = typeof model.unitType.design !== 'undefined'

        const renderRow = (label, design) => (
            <tr>
                <td>{label}</td>
                <td>{design.temperature.value} {design.temperature.unit}</td>
                <td>{design.pressure.value} {design.pressure.unit}</td>
                <td>{design.pn.value}</td>
            </tr>
        )

        return (
            <div className="configuration-editor-summary-ut-section">
                <div>{__('Design data')}</div>
                <div>
                    <table className="configuration-editor-summary-table-multi">
                        <thead>
                        <tr>
                            <th></th>
                            <th>{__('Temperature')}</th>
                            <th>{__('Pressure')}</th>
                            <th>{__('PN')}</th>
                        </tr>
                        </thead>

                        <tbody>
                        {hasDesignData && renderRow(__('District design'), model.unitType.design)}
                        {hasHeating1DesignData && renderRow(model.heating1.name.value, model.heating1.design)}
                        {hasHeating2DesignData && renderRow(model.heating2.name.value, model.heating2.design)}
                        {hasHeating3DesignData && renderRow(model.heating3.name.value, model.heating3.design)}
                        {hasDHWDesignData && renderRow(model.dhw.name.value, model.dhw.design)}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    renderThumbnail() {

    }

    renderDifferentialPressure() {
        return (
            <div className="configuration-editor-summary-ut-section">
                <div>{__('Differential pressure')}</div>
                <div style={{border: '0'}}>
                    {this.props.model.unitType.minDifferentialPressure.value} - {this.props.model.unitType.maxDifferentialPressure.value} {this.props.model.unitType.maxDifferentialPressure.unit}
                </div>
            </div>
        )
    }
}